import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

export const LOADING_ADDRESSES = () => ({ type: 'LOADING_ADDRESSES', });
export const LOADING_ADDRESSES_SUCCESS = () => ({ type: 'LOADING_ADDRESSES_SUCCESS', });
export const LOADING_ADDRESSES_ERROR = () => ({ type: 'LOADING_ADDRESSES_ERROR', });

// export const ADDING_ADDRESSES = () => ({ type: 'ADDING_ADDRESSES', });
// export const ADDING_ADDRESSES_SUCCESS = () => ({ type: 'ADDING_ADDRESSES_SUCCESS', });
// export const ADDING_ADDRESSES_ERROR = () => ({ type: 'ADDING_ADDRESSES_ERROR', });

// export const UPDATING_ADDRESSDB = () => ({ type: 'UPDATING_ADDRESSDB', });
// export const UPDATING_ADDRESSDB_SUCCESS = () => ({ type: 'UPDATING_ADDRESSDB_SUCCESS', });
// export const UPDATING_ADDRESSDB_ERROR = () => ({ type: 'UPDATING_ADDRESSDB_ERROR', });

// export const LOADING_ADDRESSDBS = () => ({ type: 'LOADING_ADDRESSDBS', });
// export const LOADING_ADDRESSDBS_SUCCESS = () => ({ type: 'LOADING_ADDRESSDBS_SUCCESS', });
// export const LOADING_ADDRESSDBS_ERROR = () => ({ type: 'LOADING_ADDRESSDBS_ERROR', });

// export const DELETING_ADDRESSDB = () => ({ type: 'DELETING_ADDRESSDB', });
// export const DELETING_ADDRESSDB_SUCCESS = () => ({ type: 'DELETING_ADDRESSDB_SUCCESS', });
// export const DELETING_ADDRESSDB_ERROR = () => ({ type: 'DELETING_ADDRESSDB_ERROR', });

//export const UPDATING_ADDRESSDB_CHECKS = () => ({ type: 'UPDATING_ADDRESSDB_CHECKS', });

export const FINDING_ADDRESSES = () => ({ type: 'FINDING_ADDRESSES', });
export const FINDING_ADDRESSES_SUCCESS = () => ({ type: 'FINDING_ADDRESSES_SUCCESS', });
export const FINDING_ADDRESSES_ERROR = () => ({ type: 'FINDING_ADDRESSES_ERROR', });

export const GETTING_POSITION_TO_ADDRESS = () => ({ type: 'GETTING_POSITION_TO_ADDRESS', });
export const GETTING_POSITION_TO_ADDRESS_SUCCESS = () => ({ type: 'GETTING_POSITION_TO_ADDRESS_SUCCESS', });
export const GETTING_POSITION_TO_ADDRESS_ERROR = () => ({ type: 'GETTING_POSITION_TO_ADDRESS_ERROR', });


export const getAddresses = (type, dispatch) => {
  dispatch({ type: LOADING_ADDRESSES });

  axios
    .get(`${serverURI}/api/address/type/all/${type}`)
    .then((res) => {
      dispatch({
        type: LOADING_ADDRESSES_SUCCESS,
        payload: res.data.addresses
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_ADDRESSES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const findAddresses = (find, dispatch) => {
  dispatch({ type: FINDING_ADDRESSES });

  axios
    .post(`${serverURI}/api/address/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_ADDRESSES_SUCCESS, 
        payload: res.data.results
        });
    })
    .catch((err) => {
      dispatch({ type: FINDING_ADDRESSES_ERROR, payload: err });
      errorHandler(err);
    });
};


export const getPositionToAddress = (position, dispatch) => {
  dispatch({ type: GETTING_POSITION_TO_ADDRESS });

  axios
    .post(`${serverURI}/api/address/position_to_address`, position)
    .then((res) => {
      console.log(res);
      dispatch({ type: GETTING_POSITION_TO_ADDRESS_SUCCESS,
        payload: res.data.address
        });
    })
    .catch((err) => {
      dispatch({ type: GETTING_POSITION_TO_ADDRESS_ERROR, payload: err });
      errorHandler(err);
    });
};
